import React, { Fragment } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'

interface ApTextareaProps {
  name: string
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  rules?: object
}

const ApCheckbox: React.FC<ApTextareaProps> = ({ name, index, register, errors, rules }) => {
  return (
    <Fragment>
      <div className='col-md-1'>
        <input type='radio' {...register(name, rules)} id={`custom-checkbox${index}0`} value={0} />
        <label htmlFor={`custom-checkbox${index}0`} className='red'>
          Red
        </label>
      </div>
      <div className='col-md-1'>
        <input type='radio' {...register(name, rules)} id={`custom-checkbox${index}1`} value={1} />
        <label htmlFor={`custom-checkbox${index}1`} className='yellow'>
          Yellow
        </label>
      </div>
      <div className='col-md-1'>
        <input type='radio' {...register(name, rules)} id={`custom-checkbox${index}2`} value={2} />
        <label htmlFor={`custom-checkbox${index}2`} className='green'>
          Green
        </label>
      </div>

      {errors && errors.coreValues && (
        <div className='invalid-feedback'>{errors.coreValues[index]?.employee_score?.message}</div>
      )}
    </Fragment>
  )
}

export default ApCheckbox
